import { render, staticRenderFns } from "./receipt-account-form-dialog.vue?vue&type=template&id=708337c6&scoped=true"
import script from "./receipt-account-form-dialog.vue?vue&type=script&lang=js"
export * from "./receipt-account-form-dialog.vue?vue&type=script&lang=js"
import style0 from "./receipt-account-form-dialog.vue?vue&type=style&index=0&id=708337c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708337c6",
  null
  
)

export default component.exports